import {throttle} from 'throttle-typescript';
import Axios from "axios";

// ref https://github.com/UniversityofWarwick/tabula/blob/develop/web/src/main/assets/static/js/errorreporter.js
// (ISC License)
// rewritten to send events straight away, and in Typescript
export class ErrorReporting {
    private throttledReportingFunction: Function;

    private onError(message, source, line, column, error) {
        const errorObj: ErrorReport = new ErrorReport(
            new Date().getTime(),
            message,
            source || error.filename || '', // path to the script where the error was raised (string),
            line || error.lineNumber || '',
            column || error.columnNumber || '',
            navigator.userAgent,
            window.location.href, // page url
        error.stack || "stack trace unavailable"
        );
        console.log(this);
        console.log(typeof(this));

        this.throttledReportingFunction(errorObj);
    }

    public reportCustomError(error) {
        this.onError(error.message, null, null, null, error);
    }

    private post(errorObj: object): void {
        Axios.post<IErrorReport, string>("/report/error", errorObj).catch(e => {
            console.error("Error whilst reporting error to server", e);
        });
    }

    public init() {
        this.throttledReportingFunction = throttle(this.post, 150);
        window.onerror = (message, source, line, column, error) => {
            this.onError(message, source, line, column, error);
        };
        if (window.addEventListener) {
            window.addEventListener('unhandledrejection', (e: PromiseRejectionEvent) => {
                // e: https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
                const message = (e.reason && e.reason.message) ? ` (${e.reason.message})` : '';
                this.onError(
                    `Unhandled promise rejection: ${e.reason}${message}`,
                    null,
                    null,
                    null,
                    e.reason,
                );
                e.preventDefault();
            });
        }
    }
}

interface IErrorReport {
    time: number,
    message: string,
    source: string,
    line: number,
    column: number,
    ua: string,
    pageUrl: string,
    stack: string
}

class ErrorReport implements IErrorReport {
    time: number;
    message: string;
    source: string;
    line: number;
    column: number;
    ua: string;
    pageUrl: string;
    stack: string;


    constructor(time: number, message: string, source: string, line: number, column: number, ua: string, pageUrl: string, stack: string) {
        this.time = time;
        this.message = message;
        this.source = source;
        this.line = line;
        this.column = column;
        this.ua = ua;
        this.pageUrl = pageUrl;
        this.stack = stack;
    }
}
